import ContextMenu from './renderers/ContextMenu';

export const menuConfig = {
  defRenderer: ContextMenu,
  defRendererProps: {},
}
